import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getAdminModuleById } from '@/config/adminModules';

interface AdminPlaceholderPageProps {
  moduleId: string;
}

export function AdminPlaceholderPage({ moduleId }: AdminPlaceholderPageProps) {
  const { t } = useTranslation('entity-portal');
  const moduleDefinition = getAdminModuleById(moduleId);
  const moduleName = moduleDefinition
    ? t(moduleDefinition.nameKey)
    : moduleId;

  return (
    <Box
      sx={{
        minHeight: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        bgcolor: 'background.default',
      }}
    >
      <Stack spacing={1} alignItems="center" textAlign="center" maxWidth={480}>
        <Typography variant="h5">
          {moduleName}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('admin.adminModuleComingSoon')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('admin.adminModuleComingSoonDescription')}
        </Typography>
      </Stack>
    </Box>
  );
}
